import { HTTP } from "./common";

export const SlideApi = {

  slides(filter) {
    return HTTP.get(`slides/?${filter?filter:''}`).then((response) => {
      return response.data;
    });
  },
  slide_detail(id) {
    return HTTP.get(`slides/${encodeURIComponent(id)}/`).then((response) => {
      return response.data;
    });
  },
  layouts() {
    return HTTP.get(`slide_layouts/`).then((response) => {
      return response.data;
    });
  },
  layout_detail(name) {
    return HTTP.get(`slide_layouts/${encodeURIComponent(name)}/`).then((response) => {
      return response.data;
    });
  },
  icons(name) {
    return HTTP.get(`slide_icons/${name?`?name=${encodeURIComponent(name)}`:''}`).then((response) => {
      return response.data;
    });
  },
};
